export default {
  fixed: 'Fest',
  variable: 'Variabel',
};
